import _ from 'lodash';
import xss from 'xss';
import linkifyHtml from 'linkifyjs/html';

function titleize() {
  return _.startCase(_.toLower(this));
}

function toReactHtml({ linkify }: { linkify?: boolean } = {}) {
  let html = xss(this);
  if (linkify) html = linkifyHtml(html);
  return { __html: html };
}

declare global {
  interface String {
    titleize: typeof titleize;
    toReactHtml: typeof toReactHtml;
  }
}

Object.assign(String.prototype, { titleize, toReactHtml });
